import React, { useEffect, useRef, useState } from "react";
import { getToken } from "./api";

const FALLBACK = "/dog-placeholder.svg";
const PATH = /^\/api\/dogs\/[A-Za-z0-9_-]+\/health-documents\/[A-Za-z0-9_-]+\/image$/;

export default function PrivateDocumentImage({ src, ...props }) {
  const [image, setImage] = useState(null);
  const element = useRef(null);
  useEffect(() => {
    const token = getToken();
    const controller = new AbortController();
    let active = true;
    let objectUrl = null;
    const clear = () => {
      active = false;
      controller.abort();
      if (element.current) element.current.src = FALLBACK;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = null;
      setImage(null);
    };
    const storage = (event) => {
      if (event.key === null || event.key === "pawcita:token") clear();
    };
    window.addEventListener("pawcita-session-changed", clear);
    window.addEventListener("storage", storage);
    setImage(null);
    if (token && typeof src === "string" && PATH.test(src)) {
      (async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || ""}${src}`, {
            headers: { Authorization: `Bearer ${token}` },
            signal: controller.signal, cache: "no-store", redirect: "error",
          });
          if (!response.ok || !active || getToken() !== token) return;
          const blob = await response.blob();
          if (!active || controller.signal.aborted || getToken() !== token) return;
          objectUrl = URL.createObjectURL(blob);
          setImage({ src, token, url: objectUrl });
        } catch { /* Private content never falls back to an unauthenticated URL. */ }
      })();
    }
    return () => {
      window.removeEventListener("pawcita-session-changed", clear);
      window.removeEventListener("storage", storage);
      clear();
    };
  }, [src]);
  const visible = image && image.src === src && image.token === getToken();
  return <img {...props} ref={element} src={visible ? image.url : FALLBACK} />;
}
